import PropTypes from 'prop-types';

// Utils
import { cn } from 'utils';

// Components
import TextBlock from '../../molecules/TextBlock/TextBlock';
import CardsCarousel from '../../atoms/CardsCarousel/CardsCarousel';
import ServiceCard from '../../atoms/ServiceCard/ServiceCard';
import ServiceTitle from '../../atoms/ServiceTitle/ServiceTitle';

// Styles
import styles from './ServicesBlock.module.css';

function ServicesBlock({
  title, subtitle, content, services, theme,
  className,
}) {
  return (
    <div className={cn([styles.wrapper, styles[theme], className])}>
      <div className={styles.container}>
        <div className={styles.content}>
          <TextBlock
            title={title}
            subtitle={subtitle}
            content={content}
            theme={theme}
            className={styles.title}
          />
        </div>
        <div className={styles.services}>
          {services?.length ? services.map(({ data }) => (
            <div key={data?.title} className={styles.servicesContainer}>
              <ServiceTitle
                title={data?.title}
                theme={theme}
                className={styles.servicesTitle}
              />
              <CardsCarousel list={data?.services} uniqueKey="title" theme={theme}>
                {({ data: dataService }) => (
                  <ServiceCard
                    media={dataService?.media}
                    title={dataService?.title}
                    content={dataService?.content}
                    tag={dataService?.tag}
                    theme={theme}
                  />
                )}
              </CardsCarousel>
            </div>
          )) : null}
        </div>
      </div>
    </div>
  );
}

ServicesBlock.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.string,
  services: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
      services: PropTypes.arrayOf(PropTypes.shape({
        media: PropTypes.shape({
          url: PropTypes.string,
          alternativeText: PropTypes.string,
        }),
        title: PropTypes.string,
        content: PropTypes.string,
      })),
    }),
  })),
  theme: PropTypes.oneOf(['light', 'dark', 'neutral', '']),
  className: PropTypes.string,
};

ServicesBlock.defaultProps = {
  title: '',
  subtitle: '',
  content: '',
  services: [],
  theme: 'light',
  className: '',
};

export default ServicesBlock;
